import React, { ComponentPropsWithoutRef, FC } from 'react';

import { useTheme } from '@mui/material';
import { motion } from 'framer-motion';

import { Svg } from '~/assets/icons/styles';

const TickOutlinedAnimatedIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();
  return (
    <Svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={theme.palette.common.green}
      {...props}
    >
      <motion.path
        initial={{ pathLength: 1, pathOffset: 1 }}
        animate={{ pathLength: 1, pathOffset: 0 }}
        transition={{
          duration: 0.8,
          ease: 'easeInOut',
        }}
        d="M22.6948 4.46986C20.0388 2.92906 16.9319 2.35345 13.9001 2.84048C10.8684 3.32751 8.09815 4.84726 6.05835 7.14242C4.01855 9.43758 2.83456 12.3671 2.70684 15.4351C2.57913 18.503 3.51553 21.5208 5.35751 23.9776C7.19948 26.4343 9.83386 28.1791 12.8146 28.9164C15.7954 29.6537 18.9393 29.3383 21.7142 28.0236C24.4891 26.7089 26.7245 24.4757 28.0417 21.702C29.359 18.9283 29.6773 15.7846 28.9428 12.8032"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <motion.path
        initial={{ visibility: 'hidden', pathLength: 0 }}
        animate={{ visibility: 'visible', pathLength: [null, 0.4, 1] }}
        transition={{
          duration: 0.6,
          ease: 'easeInOut',
          delay: 0.8,
        }}
        d="M9.33594 14.6667L14.6693 20L26.6693 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default TickOutlinedAnimatedIcon;
